import React, { useEffect } from 'react'
import {Navigate, useLocation} from "react-router-dom"
import { useAppSelector } from '../redux/hooks';
import useLogin from '../hooks/useLogin';

const ProtectedRoute = ({children}:any) => {

    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
    const { validateToken } = useLogin();
    
    let location = useLocation();

    // Ejecutar validateToken una vez cuando se monta el componente protegido
    // Esto asegura que el registro de dispositivo se ejecute al menos una vez por sesión
    useEffect(() => {
        const runValidation = async () => {
            const token = localStorage.getItem("token");
            if (token && isAuthenticated) {
                await validateToken();
            }
        };
        
        runValidation();
    }, []); // Solo se ejecuta una vez al montar el componente

    if (!isAuthenticated && location.pathname !== '/instrucciones') {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return children

};

export default ProtectedRoute;
